import "babel-polyfill"
import Vue from 'vue'
import App from './App'
import router from './router'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

//公共css样式
import '@/assets/css/public.css';

//Vuex
import store from './store.js';
//日期格式化
import { formatDate } from "@/common/formatDate.js";
//金额格式化
import { formatMoney } from '@/common/accounting.js';
//金额转化为number
import { Amount } from '@/common/Amount.js';

Vue.use(ElementUI);
Vue.config.productionTip = false

// 引入http请求地址
import { iHttp, iStorage } from 'smart-core-util'
iStorage.install()
import url from "../../scripts/configs/urs";

import { Message } from 'element-ui';
// 引入rem.js
import './assets/js/rem'
import './global'

Vue.prototype.formatDate = formatDate;
Vue.prototype.formatMoney = formatMoney;
Vue.prototype.Amount = Amount;
Vue.prototype.url = url;
Vue.prototype.iStorage = iStorage;
// 添加
Vue.prototype.customOrigin = "web"

Vue.prototype.api = new iHttp({
    baseURL: iStorage.getUrlGateway(),
    alert: function (message) {
      Message({ message: message })
    }
    // block: indicator.open,
    // unblock: loadingInstance.close;
}).api


// // 监听到数据后再实例化对象
// window.addEventListener("message", function(e){
//   if (!e.data || !e.data || e.data.from != "simulator") return;
//   iStorage.setAll(e.data.sessionData);
//   Vue.prototype.api = new iHttp({
//     baseURL: iStorage.getUrlGateway(),
//     // alert: MintUI.Toast,
//     // block: indicator.open,
//     // unblock: loadingInstance.close;
//   }).api
//   new Vue({
//     el: '#app',
//     router,
//     components: { App },
//     template: '<App/>'
//   })
// }, false);


new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  mounted: function () {
    window.addEventListener("message", this.receiveMessage, false);
  },
  methods: {
    receiveMessage: function (e) {
      if (!e.data || !e.data || e.data.from != "simulator") return;
      console.log(e.data);
      iStorage.setAll(e.data.sessionData);
      // if(e.data.sessionData.componentName == 'attenderEditor'){
        this.$router.push("/" + e.data.sessionData.componentName);
      // }
      Vue.prototype.api.baseURL = iStorage.getUrlGateway();
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js